import $$ from 'cmn-utils'
import { wxBaseUrl} from "@/config"
import store from "../../store";

// const baseUrl = "/api/core/ota/";
export default {
    getToken: (params) => {
        return $$.post('/user/login', params)
    },
    auth: () => {
        const url = encodeURIComponent(window.location.href)
        const appId = store.getters['wechat/appId'];
        window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appId +
            "&redirect_uri=" +
            url +
            "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
    },
    getAppId: (params) => {
        return $$.get(wxBaseUrl + '/api/mp/mp-info', params)
    },
    getOpenId: (params) => {
        return $$.get(wxBaseUrl + '/api/mp/getOpenId', params)
    },
    getSDK: (params) => {
        return $$.get(wxBaseUrl + '/api/wechat/jssdk-config', params)
    },
    association: (params) => {
        return $$.post(wxBaseUrl + '/api/wechat/association', params)
    },
    unbind: (params) => {
        return $$.post(wxBaseUrl + '/api/wechat/unbind', params)
    },
    getAccessToken: (params) => {
        return $$.get(wxBaseUrl + '/api/wechat/get-access-token', params)
    }
}